import { createTheme } from '@mui/material/styles';

const pinkTheme = (mode: 'light' | 'dark') =>
  createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
      },
    },
    palette: {
      mode,
      primary: {
        main: '#874B6D', // "primary" -> main
        light: '#eaddff', // "primary container"
        dark: '#533746', // "on primary container"
        contrastText: '#ffffff', // "on primary"
      },
      secondary: {
        main: '#625b71', // "secondary"
        light: '#e8def8', // "secondary container"
        dark: '#1d192b', // "on secondary container"
        contrastText: '#ffffff', // "on secondary"
      },
      error: {
        main: '#b3261e', // "error"
        light: '#f9dedc', // "error container"
        dark: '#410e0b', // "on error container"
        contrastText: '#ffffff', // "on error"
      },
      background: {
        default: mode === 'light' ? '#FFF8F8' : '#121212',
        paper: mode === 'light' ? '#ffffff' : '#1d1d1d',
      },
      text: {
        primary: '#211A1D', // "on background"
        secondary: '#49454f', // "on surface variant"
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          contained: {
            width: '100%',
            textTransform: 'none',
            borderRadius: '30px',
            fontWeight: '400',
            padding: '10px',
          },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          paper: {
            backgroundColor: mode === 'light' ? '#F9EAEF' : '#121212',
            color: mode === 'light' ? '#211A1D' : '#ffffff',
          },
        },
      },
    },
  });

export default pinkTheme;
